import React from "react";
import { isWhiteLabel } from "../services/agencyService";

const DisclosureText: React.FC = () => {
  return (
    <p className="secondary-text">
      {isWhiteLabel() ? "We" : "Potions"} <b>never</b> plagiarize{isWhiteLabel() ? "" : "s"} content or bypass{isWhiteLabel() ? "" : "es"} paywalls. At most,
      we'll give a short summary of the content you provide, and link back to
      the original source.
    </p>
  );
};

export default DisclosureText;
